<template>
  <span>

    <v-menu bottom left offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" elevation="0" icon>
          <v-icon>mdi-apps</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item href="https://muni-risk.risq.io/">
          Municipal Bond ESG Data UI
        </v-list-item>
        <v-list-item href="https://rmbs.level11analytics.com/">
          MBS ESG Data UI
        </v-list-item>
      </v-list>
    </v-menu>


    <v-menu bottom left offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" elevation="0">
          {{ userName }}
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item :to="`/logout`">
          <v-icon left> mdi-logout </v-icon>
          Log out
        </v-list-item>
      </v-list>
    </v-menu>
  </span>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "UserMenu",
  computed: {
    ...mapState(["user"]),
    userName() {
      if (this.user) {
        return this.user.name
      } else {
        return ""
      }
    }
  }

};
</script>
<style scoped>
.v-btn {
  text-transform: none;
  font-weight: 400;
  letter-spacing: normal;
}
</style>
